import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions';

// Custom Components
import { ActionButton } from 'components/Form/Buttons/ActionButton';
import { CancelButton } from 'components/Form/Buttons/CancelButton';

import FlatButton from 'material-ui/FlatButton';

import { constants, photoURLs } from 'constants/index';
import { Form, Field } from 'react-final-form'
import { isEmail } from 'components/Form/validation';
import { withRouter } from 'react-router-dom';

class VerificationStep extends React.Component {
    componentWillReceiveProps(nextProps) {
        // console.log('%cSERVER ERROR @ CWRP:','color: gold');
        // console.log(nextProps.errorData);
        // if (this.props.errorData !== nextProps.errorData){
        //     console.log('changing error state from', this.state.errors);
        //     this.setState({
        //         errors: nextProps.errorData
        //     }, ()=>{
        //         console.log('%cNEW ERROR STATE IS:','color: greenyellow');
        //         console.log(this.state.errors);
        //     })
        // }
        if ((this.props.emailIsVerified !== nextProps.emailIsVerified) && !!nextProps.emailIsVerified) {
            console.log('EMAIL HAS BEEN VERIFIED NOW CHANGING TO NEXT SCREEN', nextProps.emailIsVerified);
            // window.location.reload();
            this.props.notifyUser({
                visible: true,
                message: 'Congratulations, your account has been successfully activated!',
                textColor: 'white'
            })
            .then((res) => {
                if (this.props.isAuthFlow === true || this.props.isAuthFlow === false) {
                    this.props.advanceStepper();
                } else {
                    this.props.handleClose();
                }
            })
            .catch(console.log);
        }
    }

    render(){
        const { handleClose, stepperControls, user } = this.props;
        const { reverseStepper, advanceStepper } = stepperControls;
        // const onSubmit = async values => {
        //     this.props.resendVerification(user.id , values.email);
        // }
        const TextFieldAdapter = ({ input, meta, ...rest }) => (
            <div>
                <input 
                    {...input}
                    {...rest}
                />
                <span style={{ color: 'red' }}>{meta.touched ? meta.error : ''}</span>
            </div>
        );
        return (
            <div label="Activate Account">
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        <img src={photoURLs.verificationEmailClickAnimation} />
                    </div>
                    <h3 style={{ marginTop: 5 }}>Almost done!</h3>
                    <p>Check your email and click the link we sent you to activate your account.</p> 
                </div>
                <div>
                    <h4>Didn't Get an Email? Try these steps:</h4>
                    <div>1. Check your spam folder.</div>
                    <div>2. 
                        <ActionButton options={{
                            label: "resend", 
                            isNextButton: false,
                            action: ()=>{
                                console.log('USER', user);
                                this.props.resendVerification(user.uid || user.id , user.email);
                            }
                        }} />
                    </div>
                    <div>3. Or you can
                        <FlatButton
                            label="Cancel & Sign Out"
                            disableTouchRipple={true}
                            disableFocusRipple={true}
                            onClick={(event)=>{
                                this.props.logOut(this.props.history, this.props.updateLocation)
                            }}
                            style={{marginRight: 12, color: constants.color.primary}}
                        /> (You can always activate at a later time. Just sign in using the email and password you just created.)
                    </div>
                </div>
            </div>
        );
    }

    // const handleVerification = () => {
    //     props.verifyEmailCode(user.id);
    // }
}

const mapStateToProps = ({ auth }) => {
    return {
        user: auth.authData,
        emailIsVerified: auth.verificationStatus,
        isAuthFlow: auth.isAuthFlow,
    };
}

const styles= {
    inputStyles: { 
        width: '100%', 
        padding: 10, 
        fontSize: 14, 
        borderRadius: '5px 5px 5px 5px', 
        borderColor: 'transparent', 
        borderWidth: 0, 
        backgroundColor: 'rgba(220,220,220, 0.6)',
        fontFamily: 'Open Sans',
        flex: 1,
        marginRight: 50,
    },
    formFieldStyles: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'flex-start',
        marginBottom: 15 
    },
    buttonStyles: { 
        padding: 10, 
        backgroundColor: constants.color.primary, 
        borderRadius: '0 3px 3px 0',
        borderWidth: 0,
        fontSize: 14,
        fontFamily: 'Open Sans',
        marginRight: 15,
        color: 'white',
        height: 39,
    }
}

export const VerificationStepDisconnected = VerificationStep;
export default withRouter(connect(mapStateToProps, actions)(VerificationStep));


// WEBPACK FOOTER //
// ./src/js/components/Form/Steps/VerificationStep.jsx